import React from "react";
import { useState } from "react";
import { Alert, Button, Form, Input, Space } from "antd";
import {
  resetPassword,
  forgotPassword,
} from "shared/services/auth-services/auth_service";
import "./UserResetPassword.css";

export const UserResetPasswordPage = () => {
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);
  const [message, setMessage] = useState("");

  const [email, setEmail] = useState("");

  const handleSendResetPasswordEmail = () => {
    if (!email) {
      setError("Please enter your email address.");
      return;
    }
    setProcessing(true);
    setError("");
    setMessage("");

    forgotPassword(email)
      .then(() => {
        setMessage(
          "Password reset code sent successfully. Please check your email."
        );
        setError("");
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  const handleChangePassword = ({
    email,
    resetCode,
    newPassword,
    confirmPassword,
  }) => {
    setProcessing(true);
    setError("");
    setMessage("");

    if (newPassword !== confirmPassword) {
      setError("The confirm password that you entered does not match!");
      setProcessing(false);
      return;
    }

    resetPassword(email, resetCode, newPassword)
      .then(() => {
        setMessage("Password changed successfully.");
        setError("");
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  return (
    <div className="reset-password-container">
      <h2>Reset Password</h2>
      <Form
        layout="vertical"
        onFinish={handleChangePassword}
        className="change-password-body"
      >
        {error && <Alert type="error" message={error} banner />}
        {message && <Alert type="success" message={message} banner />}

        <div className="email-container">
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please input a valid email address!",
              },
            ]}
          >
            <Input value={email} onChange={(e) => setEmail(e.target.value)} />
          </Form.Item>
        </div>

        <div>
          <div className="reset-code-container">
            <div
              className="reset-password-btn-container"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                type="primary"
                block
                style={{ width: "50%" }}
                loading={processing}
                onClick={handleSendResetPasswordEmail}
              >
                Send Verification Code
              </Button>
            </div>
            <Form.Item
              label="Verification Code"
              name="resetCode"
              rules={[
                {
                  required: true,
                  message:
                    "Please input the verification code sent to your email!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </div>

          <div className="password-container">
            <Form.Item
              label="New Password"
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your new password!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm New Password"
              dependencies={["newPassword"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm your new password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The confirm password that you entered does not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </div>

          <div
            className="change-password-btn-container"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button type="primary" block loading={processing} htmlType="submit">
              Change Password
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};
